const TYPE = 's3-extension'

export default interface Config {
    accessKey: string
    secretKey: string
    cron: string
    bucketName: string
}

export { TYPE }